<template>
  <v-container>
    <div v-if="collaborator">
      <the-header :title="getLabel('collaborator_profile')" :go-back="goBack" />
      <v-card elevation="5" class="rounded-lg">
        <v-tabs v-model="tab" elevation="3" background-color="primary" dark height="64px" show-arrows>
          <v-tabs-slider />
          <v-tab v-for="tab in tabsItems" :key="tab.label">{{ tab.label }}</v-tab>
        </v-tabs>
        <v-card-text class="pa-0">
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="tab in tabsItems" :key="tab.label">
              <component :is="tab.component" />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </div>
    <v-alert v-else prominent type="error" class="text-h5">
      {{ getLabel("collaborator_not_found") }}
    </v-alert>
  </v-container>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import { useQuery } from '@vue/apollo-composable';
import { useMainStore } from '../../store/index';

import { getGraphqlSchema } from '../../graphql/index';
import { getLabel } from '@/utils/index';

import TheHeader from '../UI/TheHeader.vue';
import CollaboratorProfile from '../profile/CollaboratorProfile.vue';
import CollaboratorAyantDroits from '../profile/CollaboratorAyantDroits.vue';
import CollaboratorResources from '../profile/CollaboratorResources.vue';
import CollaboratorContracts from '../profile/CollaboratorContracts.vue';
import CollaboratorHabilitations from '../profile/CollaboratorHabilitations.vue';

export default {
  name: 'ManageProfile',
  components: {
    TheHeader,
    CollaboratorProfile,
    CollaboratorAyantDroits,
    CollaboratorResources,
    CollaboratorHabilitations,
    CollaboratorContracts
  },
  setup () {
    const route = useRoute();

    const router = useRouter();

    const store = useMainStore();

    const tab = ref(0);

    const tabsItems = [
      { label: getLabel('collaborator'), component: 'CollaboratorProfile' },
      { label: getLabel('assigns'), component: 'CollaboratorAyantDroits' },
      { label: getLabel('habilitations'), component: 'CollaboratorHabilitations' },
      { label: getLabel('ressources'), component: 'CollaboratorResources' },
      { label: getLabel('contracts'), component: 'CollaboratorContracts' }
    ];

    const dialog = ref(false);

    const showDialog = () => {
      dialog.value = true;
    };

    // Get Collaborator
    store.loading = true;

    store.collaborator = null;

    const variables = { uuid: route.params.uuid };

    const { onResult, onError } = useQuery(getGraphqlSchema('collaborator'), variables, { fetchPolicy: 'no-cache' });

    onResult(result => {
      if (result.loading) {
        store.loading = true;
        return;
      }

      if (result.data.collaborator) {
        store.collaborator = result.data.collaborator;
        ['restrictions', 'groups', 'readWorkspaces', 'writeWorkspaces'].forEach(key => store.collaborator[key] ??= []);
      }

      store.loading = false;
    });

    onError(() => {
      store.loading = false;
      store.collaborator = null;
    });
    /** *************************************************** */

    const collaborator = computed(() => store.collaborator);

    const collaboratorFullName = computed(() => {
      const first = collaborator.firstname === null ? '' : collaborator.firstname;
      const last = collaborator.lastname === null ? '' : collaborator.lastname;
      return `${first} ${last}`;
    });

    const goBack = () => {
      if (store.search.query === '') {
        router.push({ name: 'dashboard' }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error;
          }
        });
        return;
      }
      router.push({ name: 'search', params: { query: store.search.query } }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error;
        }
      });
    };

    return {
      getLabel,
      tab,
      tabsItems,
      dialog,
      showDialog,
      collaborator,
      collaboratorFullName,
      goBack
    };
  }
};

</script>

<style lang="scss">
</style>
